







import { Component, Vue } from 'vue-property-decorator';

@Component({
    name: 'GlobalOverlayBellButton',
})
export default class GlobalOverlayBellButton extends Vue {
    constructor() {
        super();
    }

    get unreadNotificationCount(): boolean {
        return this.$store.getters['TenantNotifications/getTenantUnreadNotificationsCount'] > 0;
    }
}
